<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to"/>
      <masked-input
        type="tel"
        :name="validationLabel || label"
        :key="label"
        :required="required"
        :id="save_to"
        v-model="val"
        :autocomplete="autocomplete"
        :pipe="autoCorrectedDatePipe"
        :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
        :placeholder="placeholder"
        inputmode="tel"
        @blur.native="onBlur()"
        @change.native="onChange()"
        v-validate="rules"
      />
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="error && errors.has(validationLabel || label)">{{ errors.first(validationLabel || label) }}</span>
  </div>
</template>

<script>
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedInput from 'vue-text-mask';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';

export default {
  name: 'DateInput',
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    min: String,
    max: String,
    validationLabel: String,
    required: Boolean,
    isBirthBate: Boolean,
    dateMaxToday: Boolean,
    placeholder: {
      type: String,
      default: 'jj/mm/aaaa'
    },
  },
  data: function () {
    return {
      createAutoCorrectedDatePipe: createAutoCorrectedDatePipe,
      autocomplete: (this.isBirthBate)?'bday':undefined,
    };
  },
  computed: {
    rules () {
      const a = {
        required: this.required,
        date_format: 'dd/MM/yyyy'
      };
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      if(!isIE) {
        let max = (this.dateMaxToday)?(new Date()).toLocaleDateString('fr'):(new Date(this.max)).toLocaleDateString('fr');
        let min = (new Date(this.min)).toLocaleDateString('fr');
        if (this.min !== undefined && (this.max !== undefined || this.dateMaxToday)) a.date_between = [min, max, true];
        else if (this.min !== undefined) a.after = [min, true];
        else if (this.max !== undefined || this.dateMaxToday) a.before = [max, true];
      }
      return a;
    },
  },
  methods: {
    autoCorrectedDatePipe: createAutoCorrectedDatePipe('dd/mm/yyyy HH:MM'/*, {
      minYear: this.min,
      maxYear: this.max
    } */)
  }
};
</script>
